<template>
  <q-btn
    icon="fa fa-trash"
    size="sm"
    title="Delete"
    flat
    round
    @click="$emit('deleted')"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['deleted'],
});
</script>
